export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11154.87d8d391.jpg";